import * as React from 'react'
import { connect } from 'react-redux'

import Feedback from '../../screens/Feedback/index'
import { feedbkList } from './action'
class FeedbackContainer extends React.Component<Props, State>{
    render() {
        return <Feedback
        feedbkList={this.props.feedbkList}
        fedbckDtlsList={this.props.fedbckDtlsList}
        fedbckDtlsCount={this.props.fedbckDtlsCount}
        />
    }
}
function bindAction(dispatch) {
    return {
        feedbkList: () => {
       
            dispatch(feedbkList())
        }
    }
}
function mapStateToProps(state) {

    return {
        fedbckDtlsList: state.FeedbackReducer.fedbckDtlsList,
        fedbckDtlsCount: state.FeedbackReducer.fedbckDtlsCount
    }
  }

export default connect(mapStateToProps, bindAction)(FeedbackContainer)